module.exports = __webpack_public_path__ + "static/media/YF80_0.31159327.jpg";